import { render, staticRenderFns } from "./FormFornecedorFone.vue?vue&type=template&id=ff9aa69c"
import script from "./FormFornecedorFone.vue?vue&type=script&lang=js"
export * from "./FormFornecedorFone.vue?vue&type=script&lang=js"
import style0 from "./FormFornecedorFone.vue?vue&type=style&index=0&id=ff9aa69c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports